
export enum StandardAltitudes {
  sevenHundred = 700,
  eightHundredFifty = 850
}

export enum LocationsEnum {
  Ayas,
  Uregil,
  Alanya,
  Aksehir,
  Corum,
  Ormanli,
  Oludeniz_1700
}
export enum PrecipitationType{
  Yok = 0,
  Yağmur = 1,
}

export enum WeatherApiCallParameters {
  hourly = 'hourly',
  temp850hPa = 'temperature_850hPa',
  temp700hPa = 'temperature_700hPa',
  daily = 'daily',
  tempMax = 'temperature_2m_max',
  timeZone = 'timezone',
  auto = 'auto',
  long = 'longitude',
  lat = 'latitude',
  turkeyTimeZone = 'Europe/Istanbul',
  wind850hPaSpeed = 'windspeed_850hPa',
  wind850hPaDirection = 'winddirection_850hPa',
  wind900hPaDirection = 'winddirection_900hPa',
  wind900hPaSpeed = 'windspeed_900hPa',
  windSpeed925hPa = 'wind_speed_925hPa',
  wind925hPaDirection = 'winddirection_925hPa',
  windSpeed700hPa = 'wind_speed_700hPa',
  wind700hPaDirection = 'winddirection_700hPa',
  cloudCover = 'cloudcover',
  cloud_cover_low = 'cloud_cover_low',
  cloud_cover_mid = 'cloud_cover_mid',
  cloud_cover_high = 'cloud_cover_high',
  startDate = 'start_date',
  endDate = 'end_date',
  relativeHumidity_850hPa = 'relativehumidity_850hPa',
  relativeHumidity_700hPa = 'relativehumidity_700hPa',
  models = 'models',
  temperature_2m = 'temperature_2m',
  elevation = 'elevation',
  convective_cloud_base = 'convective_cloud_base',
  cape = 'cape',
  key = 'key',
  windGusts10m = 'wind_gusts_10m',
  precipitation='precipitation',
  precipitation_type = 'precipitation_type',
  precipitationProbabilityMax = 'precipitation_probability_max',
  dewPoint1000hPa = 'dew_point_1000hPa',
  dewPoint900hPa = 'dew_point_900hPa',
  dewPoint850hPa = 'dew_point_850hPa',
  dewPoint700hPa = 'dew_point_700hPa',
}
